import React, {useState, useEffect} from "react";
import {Button, Col, Form, message, Row, Select} from "antd";
import {DownloadOutlined} from '@ant-design/icons';
import {URL_API_RENDER_FILE3D} from "../../../config";
import UploadIMG from "./UploadIMG";

const RenderFile3D = (props) => {
    const [open, setOpen] = useState(false);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [loadingFile, setLoadingFile] = useState(false);
    const [downloading, setDownloading] = useState(false);
    const [url, setURL] = useState("");
    const [glbUrl, setGlbUrl] = useState("");
    const [scriptLoaded, setScriptLoaded] = useState(false);

    useEffect(() => {
        if (!document.querySelector('script[src*="model-viewer.min.js"]')) {
            const script = document.createElement('script');
            script.type = 'module';
            script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.0.0/model-viewer.min.js';
            script.onload = () => setScriptLoaded(true);
            document.head.appendChild(script);
        } else {
            setScriptLoaded(true);
        }

        return () => {
            // Không xóa script khi unmount vì có thể được dùng bởi component khác
        };
    }, []);

    const handleChangeFile = (v) => {
        setURL(v);
    };

    const categorys = [
        { id: "lager", title: 'Canvas Large - ABTRAST' },
        { id: "doc", title: 'Canvas Vertical - File in 16x20' },
        { id: "ngang", title: 'Canvas Horizontal - File in 20x16'},
    ];

    const onClose = () => {
        setOpen(false);
    };

    const onFinishFailed = () => {};

    const onFinish = async (values) => {
        if (!values.selectProductType) {
            message.error("Please select type product!");
            return;
        }
        if (!values.imageUrl) {
            message.error("Please upload Image!");
            return;
        }

        setLoading(true);
        try {
            const File3DRawResponse = await fetch(URL_API_RENDER_FILE3D, {
                method: 'post',
                credentials: 'same-origin',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    type_render: values.selectProductType,
                    url_image: values.imageUrl
                })
            });

            if (!File3DRawResponse.ok) {
                throw new Error(`HTTP error! status: ${File3DRawResponse.status}`);
            }

            const responseText = await File3DRawResponse.text();
            const glb3dResponse = responseText ? JSON.parse(responseText) : {};

            if (glb3dResponse.filePath) {
                setGlbUrl(glb3dResponse.filePath);
                message.success("3D file rendered successfully!");
            }
        } catch (error) {
            message.error("Failed to render 3D file: " + error.message);
        } finally {
            setLoading(false);
        }
    }

    // Hàm xử lý tải xuống file 3D
    const handleDownload = async () => {
        if (!glbUrl) {
            message.error("No 3D file available for download. Please render a model first.");
            return;
        }

        setDownloading(true);
        try {
            const fileName = glbUrl.split('/').pop();
            const response = await fetch(glbUrl);
            if (!response.ok) {
                throw new Error(`Failed to download file: ${response.status} ${response.statusText}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            window.URL.revokeObjectURL(url);
            document.body.removeChild(a);

            message.success("Download started!");
        } catch (error) {
            console.error("Download error:", error);
            message.error("Failed to download file: " + error.message);
        } finally {
            setDownloading(false);
        }
    };

    // Chuỗi HTML chứa model-viewer
    const renderModelViewer = () => {
        if (!glbUrl) return null;
        return (
            <div
                style={{ width: '100%', height: '500px' }}
                dangerouslySetInnerHTML={{
                    __html: `
                    <model-viewer
                        src="${glbUrl}"
                        alt="3D model"
                        shadow-intensity="1"
                        camera-controls
                        auto-rotate
                        style="width: 100%; height: 100%;">
                    </model-viewer>
                    `
                }}
            />
        );
    };

    return (
        <>
            <Row>
                <Col
                    span={8}
                    style={{
                        padding: 10,
                        background: "rgb(249 249 249)",
                        border: "1px solid #efefef",
                        borderRadius: 10
                    }}
                >
                    <h3>Render File 3D:</h3>
                    <div>
                        <Form
                            layout="vertical"
                            form={form}
                            name="basic"
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                            autoComplete="off"
                        >
                            <Form.Item label="Select Product Type" name="selectProductType">
                                <Select>
                                    {categorys.map((i) => (
                                        <Select.Option key={i.id} value={i.id}>
                                            {i.title}
                                        </Select.Option>
                                    ))}
                                </Select>
                            </Form.Item>

                            <Form.Item name="imageUrl" label="Image">
                                <UploadIMG onChange={handleChangeFile} />
                            </Form.Item>

                            <Form.Item>
                                <Button
                                    style={{marginTop:10,width:"100%",height:36,fontSize:15}}
                                    type="primary"
                                    htmlType="submit"
                                    loading={loadingFile || loading}
                                >
                                    Submit
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Col>
                <Col span={16} style={{
                    padding: "0px 10px"
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                        <h3>View File 3D:</h3>
                        {glbUrl && (
                            <Button
                                type="primary"
                                icon={<DownloadOutlined />}
                                onClick={handleDownload}
                                loading={downloading}
                            >
                                Download File 3D
                            </Button>
                        )}
                    </div>
                    <div style={{ width: '100%', height: '500px' }}>
                        {scriptLoaded && glbUrl ? (
                            renderModelViewer()
                        ) : !glbUrl ? (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                border: '1px dashed #ccc',
                                borderRadius: '5px',
                                color: '#999'
                            }}>
                                No 3D model to display. Please render a model first.
                            </div>
                        ) : (
                            <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                height: '100%',
                                border: '1px dashed #ccc',
                                borderRadius: '5px',
                                color: '#999'
                            }}>
                                Loading model viewer...
                            </div>
                        )}
                    </div>
                </Col>
            </Row>
        </>
    );
}

export default RenderFile3D;